import { makeStyles } from '@material-ui/core/styles';
import { colors } from 'styles/colors';
import fonts from 'styles/fonts';
import spacing from 'styles/spacing';

const useStyles = makeStyles({
  content: {
    '& section': {
      maxHeight: '250px',
      overflowY: 'auto',
      overflowX: 'hidden',
    },
    '& section > div:first-of-type': {
      width: 425,
      height: 58,
      marginLeft: 0,
      marginRight: 0,
    },

    '& section > p:first-of-type': {
      fontSize: fonts.sizes.xsmall,
      fontWeight: fonts.weights.normal,
      marginTop: spacing.xsmall,
      marginLeft: spacing.xsmall,
      letterSpacing: '0.4px',
      color: colors.gray,
    },

    '& aside > div > div:first-of-type': {
      alignItems: 'center',
    },

    '& h4': {
      fontSize: fonts.sizes.small,
      fontWeight: fonts.weights.normal,
      color: colors.uploadedItemLegend,
      lineHeight: '20px',
    },
  },
  divider: {
    marginTop: '30px',
    height: '2px',
    width: '100%',
    background: 'rgba(0, 0, 0, 0.3)',
  },
  inputList: {
    '& .MuiInputBase-root': {
      height: 'auto',
    },
    '& .MuiIconButton-root': {
      color: colors.black,
    },
  },
  formBaseInput: {
    '& .MuiFormHelperText-root': {
      color: colors.gray,
    },
  },
});

export default useStyles;
